import { useState } from "react";
import { Input } from "@mui/material";
import TextsmsOutlinedIcon from "@mui/icons-material/TextsmsOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import DriveFileRenameOutlineOutlinedIcon from "@mui/icons-material/DriveFileRenameOutlineOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import DoneOutlinedIcon from "@mui/icons-material/DoneOutlined";

import classes from "./HistoryItem.module.css";
import MUIIconButton from "../../../Component/UI/MUIIconButton/MUIIconButton";
import Modal from "../../../Component/Modal/Modal";

export default function HistoryItem({
  item,
  onDelete,
  onUpdate,
  updateStatesFromHistory,
}) {
  const [name, setName] = useState(item?.name || item.entity);
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [isError, setIsError] = useState(false);

  function deleteHistoryItemHandler() {
    setShowDeleteDialog(false);
    onDelete(item.id);
  }

  function handleDoneEditing() {
    if (isError) {
      return;
    }
    setIsError(false);
    setIsEditing(false);
    if (
      item.name.toString().toLowerCase().trim() ==
      name.toString().toLowerCase().trim()
    ) {
      return;
    }
    onUpdate(item.id, name);
  }

  function handleInputChange(e) {
    const enteredInput = e.target.value;
    if (enteredInput.trim().length === 0) {
      setIsError(true);
    } else {
      setIsError(false);
    }
    setName(e.target.value);
  }

  const handleKeyDown = (event) => {
    if (event.key === "Escape") {
      setName(item?.name || item?.entity);
      setIsError(false);
      setIsEditing(false);
    }
  };

  const type = item?.type ?? "brand";

  return (
    <div
      className={classes.container}
      style={{
        borderLeft: `4px solid ${type === "brand" ? "#1976d2" : "green"}`,
      }}
    >
      <Modal
        handleClose={() => setShowDeleteDialog(false)}
        handleConfirm={deleteHistoryItemHandler}
        open={showDeleteDialog}
        title="Delete History"
        showActions
        confirmBtnText="Delete"
        confirmBtnColor="error"
      >
        Do you want to delete this item - {name}?
      </Modal>
      <div className={classes.text_container}>
        <TextsmsOutlinedIcon />
        {!isEditing && (
          <div>
            <span title={item?.name} className={classes.text}>
              {item?.name}
            </span>
            <div className={classes.meta}>
              <span className={classes.sub_text} title={item?.category}>
                {item?.category}
              </span>
              {item?.json_data?.contentType && (
                <>
                  <span>&middot;</span>
                  <span
                    className={classes.sub_text}
                    title={item?.json_data?.contentType}
                  >
                    {item?.json_data?.contentType}
                  </span>
                </>
              )}
              {item?.market && (
                <>
                  <span>&middot;</span>
                  <span className={classes.sub_text} title={item?.market}>
                    {item?.market}
                  </span>
                </>
              )}
              {item?.json_data?.persona && (
                <>
                  <span>&middot;</span>
                  <span className={classes.sub_text} title={item?.json_data?.persona}>
                    {item?.json_data?.persona}
                  </span>
                </>
              )}
              {item?.json_data?.location && (
                <>
                  <span>&middot;</span>
                  <span className={classes.sub_text} title={item?.json_data?.location}>
                    {item?.json_data?.location}
                  </span>
                </>
              )}
            </div>
          </div>
        )}
        {isEditing && (
          <Input
            disableUnderline
            className={classes.input}
            style={{ borderColor: isError ? "red" : "gray" }}
            type="text"
            value={name}
            onKeyDown={handleKeyDown}
            onChange={handleInputChange}
          />
        )}
      </div>
      <div className={classes.action}>
        {!isEditing && (
          <>
            <MUIIconButton
              sx={{ color: "#000" }}
              // disabled={discoveryCtx.loading}
              onClick={() => {
                // console.log("item==>", item);
                updateStatesFromHistory(item,true);
                setIsEditing(false);
              }}
            >
              <VisibilityOutlinedIcon />
            </MUIIconButton>
            {/* <MUIIconButton
              sx={{ color: "#000" }}
              onClick={() => setIsEditing(true)}
            >
              <DriveFileRenameOutlineOutlinedIcon />
            </MUIIconButton> */}
            <MUIIconButton
              sx={{ color: "#000" }}
              onClick={() => setShowDeleteDialog(true)}
            >
              <DeleteOutlineOutlinedIcon />
            </MUIIconButton>
          </>
        )}
        {isEditing && (
          <MUIIconButton onClick={handleDoneEditing}>
            <DoneOutlinedIcon />
          </MUIIconButton>
        )}
      </div>
    </div>
  );
}
